<template>
  <div>
    <div class="header bg-gradient-danger py-7 pt-lg-9" :style="{'background': headerColor}">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Welcome!</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-secondary" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <b-container class="mt--9 pb-5">
      <div v-if="$route.query.url">
        <b-row class="justify-content-center">
          <b-col lg="5" md="7">
            <b-card no-body>
              <b-card-body class="px-lg-5 py-lg-5">
                <div v-if="!isAuthenticated">
                  <div class="text-center text-muted mb-4">
                    <h2>Email Verification</h2>
                    <small>Please log in to verify your email.</small>
                  </div>
                  <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                    <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                      <base-input alternative
                                  class="mb-3"
                                  name="Email"
                                  :rules="{required: true, email: true}"
                                  prepend-icon="ni ni-email-83"
                                  placeholder="Email"
                                  v-model="email">
                      </base-input>
                      <validation-error :errors="apiValidationErrors.email" />

                      <base-input alternative
                                  class="mb-3"
                                  name="Password"
                                  :rules="{required: true, min: 6}"
                                  prepend-icon="ni ni-lock-circle-open"
                                  type="password"
                                  placeholder="Password"
                                  v-model="password">
                      </base-input>
                      <validation-error :errors="apiValidationErrors.password" />

                      <div class="text-center">
                        <base-button type="danger" native-type="submit" class="my-4" :disabled="submitted">{{ submitBtn }}</base-button>
                      </div>
                    </b-form>
                  </validation-observer>
                </div>
                <loading-panel v-else></loading-panel>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <b-row class="justify-content-center" v-else>
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <h2>Verify Your Email Address</h2>
                <p>Before proceeding, please check your email for a verification link.</p>
                <p>If you did not receive the email</p>
                <b-form role="form" @submit.prevent="resendVerification">
                  <b-button block variant="danger" type="submit">click here to request another</b-button>
                </b-form>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import ValidationError from "@/components/ValidationError.vue";
import LoadingPanel from '@/components/LoadingPanel';
import errorsMixin from "@/mixins/errors-mixin";
import formMixin from "@/mixins/form-mixin";

export default {
  mixins: [errorsMixin, formMixin],
  components: {
    LoadingPanel,
    ValidationError
  },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
    }
  },
  computed: {
    user() {
      return this.$store.getters['profile/user'];
    },
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    isAuthenticated() {
      return this.$store.getters['isAuthenticated'];
    },
    submitBtn() {
      return this.submitted ? 'Processing...' : 'Sign in';
    },
    headerColor() {
      return this.user.pulse ? 'linear-gradient(87deg, #262262 40%, #DDB143 100%) !important' : '';
    }
  },
  methods: {
    async resendVerification() {
      await axios.post(process.env.VUE_APP_API_BASE_URL + "/email/verification-notification", {}, {
        headers: {
          'Content-Type': 'application/json',
          'responseType': 'json'
        }
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: 'Check your email for the verification link.',
          showConfirmButton: false,
          timer: 2000,
          icon: 'success'
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async verify(url) {
      await axios.get(url)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: 'Email has been verified successfully.',
          showConfirmButton: false,
          timer: 2000,
          icon: 'success'
        }).then(result => {
          this.$store.dispatch("profile/user").then(() => {
            this.$router.push({
              path: '/home'
            });
          });
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    checkUser() {
      if (this.user.email_verified_at) {
        this.$router.push({
          path: '/home'
        });
      } else if (this.$route.query.url) {
        this.verify(this.$route.query.url);
      }
    },
    async onSubmit() {
      this.submitted = true;
      const user = {
        email: this.email,
        password: this.password
      };

      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };

      try {
        await this.$store.dispatch("login", { user, requestOptions });
        await this.$store.dispatch("teams/get", {user: this.user.slug});

        this.checkUser();
        
      } catch (error) {
        this.submitted = false;
        this.error(error);
      }
    }
  },
  created() {
    if (this.isAuthenticated) {
      this.checkUser();
    }
  }
};
</script>